import React, { useEffect } from 'react'
import Navigation from '../../../Components/Navigation/Navigation'
import Heading from '../../../Components/Heading/Heading'
import Footer from '../../../Components/Footer/Footer'
import Hero from './Sections/Hero/Hero'
import IndustryChallengesAndSolutions from './Sections/IndustryChallengesAndSolutions/IndustryChallengesAndSolutions'
import Aos from 'aos'
import 'aos/dist/aos.css'
import homeCareMockup from '../../../assets/images/h1.png'
import h2 from '../../../assets/images/h2.png'
import IndustryTech from './Sections/IndustryTech/IndustryTech'
import AISearch from './Sections/AISearch/AISearch'
import SpecializedServices from './Sections/SpecializedServices/SpecializedServices'
import WhyChoose from './Sections/WhyChoose/WhyChoose'
import h8 from '../../../assets/images/h8.png'
import CaseStudies from '../../Home/Components/CaseStudies'
import ClientSpeak from '../../Home/Components/ClientSpeak'
import GetQuote from '../../../Components/GetQuote/GetQuote'
import Contect from '../../Home/Components/Contect'

const Homecare = () => {

    useEffect(() => {
        Aos.init({
            duration: 1000,
            once: true,
            offset: 100,
        });
    }, []);

    const homeContent = {
        title: "HomeCare App Development",
        description: "Tired of watching customers struggle to find reliable home services? We build game-changing HomeCare apps that make booking plumbers, electricians, and handymen as easy as ordering pizza. Your users get instant help, professionals stay busy.",
        image: homeCareMockup,
        breadcrumb: "Homecare",
        b: "Let's Build This Together"
    }

    const industryChallengesAndSolutionsContent = {
        challengesTitle: "Why Home Service Apps Are Bleeding Users (And How We Stop It)",
        solutionsTitle: "The Game-Changing Features That Build Unstoppable Loyalty",
        challenges: [
            {
                title: "Weak AI-Powered Platforms Still Can't Predict When Your Users Will Actually Need Help",
                description: "Most apps react after problems happen. Smart homeowners need predictive insights that prevent disasters before expensive damage occurs.",
                icon: '/images/industries/homecare/01.svg',
            },
            {
                title: 'Homeowners Waste Hours Hunting for Help During Property Disasters',
                description: 'When pipes burst at midnight, users frantically scroll through dozens of unavailable contractors while water destroys their homes.',
                icon: '/images/industries/homecare/02.svg',
            },
            {
                title: "Your Home Service App Is a Hacker's Dream Target",
                description: 'Personal addresses, payment details, and home access schedules create treasure troves for cybercriminals targeting vulnerable homeowner data.',
                icon: '/images/industries/homecare/03.svg',
            },
            {
                title: 'Most Home Apps Get Uninstalled Before the First Job Completes',
                description: 'Complicated booking flows, hidden fees, and unreliable contractors make users abandon your app before experiencing any real value.',
                icon: '/images/industries/homecare/04.svg',
            },
            {
                title: 'Your Fragmented Tech Creates Dangerous Service Gaps',
                description: 'Disconnected systems lose crucial job details, creating miscommunication that leads to botched repairs and frustrated customers who blame you.',
                icon: '/images/industries/homecare/05.svg',
            },
            {
                title: 'Contractors Vanish When Homeowners Need Them Most',
                description: "Top professionals disappear during peak demand because your platform can't prioritize urgent jobs or retain quality service providers effectively.",
                icon: '/images/industries/homecare/06.svg',
            },
        ],
        solutions: [
            {
                title: "AI-Powered Personalization That Learns Every Homeowner's Unique Preferences",
                description: "Smart algorithms remember your users' favorite contractors, preferred time slots, and service history for perfectly tailored recommendations every time.",
                icon: '/images/industries/homecare/07.svg',
            },
            {
                title: 'Disaster-Management Systems that avert Property Disasters',
                description: 'Emergency dispatch allows connecting homeowners to the professional workers who can help them in a few minutes before small issues turn into costly disasters destroying property.',
                icon: '/images/industries/homecare/08.svg',
            },
            {
                title: 'Bank-Vault Security On Which Homeowners Bet their Security',
                description: 'Military-grade encryption protects personal data while secure payment processing gives users confidence to trust your platform with sensitive information.',
                icon: '/images/industries/homecare/09.svg',
            },
            {
                title: 'Habit-Forming Tools That Make Your App Indispensable',
                description: 'Push notifications for maintenance reminders and seasonal prep keep users engaged while building dependency on your platform year-round.',
                icon: '/images/industries/homecare/10.svg',
            },
            {
                title: 'Bulletproof Integration That Eliminates All Friction',
                description: 'Seamless connections with calendars, payment systems, and smart home devices create effortless user experiences that eliminate booking headaches completely.',
                icon: '/images/industries/homecare/11.svg',
            },
            {
                title: 'We Created On-Demand Marketplaces That Deliver Instant Results',
                description: 'Real-time matching algorithms connect users with available professionals immediately, guaranteeing fast responses that exceed customer expectations every single time.',
                icon: '/images/industries/homecare/12.svg',
            },
        ]
    }

    const industryTechContent = {
        mainTitle: "The Revolutionary Tech Driving Next-Gen Home Service Apps",
        leftHeading: 'Harnessing Advanced Technologies For HomeCare App Development',
        leftParagraph: 'We believe that integrating breakthrough technology creates unprecedented service opportunities and operational efficiency. Our approach builds robust, future-proof home service platforms that keep you competitive.',
        leftImage: h2,
        performanceItems: [
            {
                title: 'Blockchain-Verified Service Records & Tamper-Proof Quality Assurance',
                description: 'Immutable service history creates trust while preventing fake reviews and fraudulent claims.',
                icon: '/images/industries/homecare/13.svg',
            },
            {
                title: 'Smart AI That Matches Perfect Pros to Every Job',
                description: 'Advanced algorithms analyze skills, location, and availability for optimal contractor-job pairing instantly.',
                icon: '/images/industries/homecare/14.svg',
            },
            {
                title: 'Preventive Care Systems and Connected Home Automation',
                description: 'IoT integrations monitor critical home systems and trigger proactive maintenance before failures.',
                icon: '/images/industries/homecare/15.svg',
            },
            {
                title: 'Secure Digital Payments & Escrow Protection',
                description: 'Encrypted payments with milestone-based escrow ensure fair payouts and eliminate disputes.',
                icon: '/images/industries/homecare/16.svg',
            }
        ]
    };

    const aiSearchContent = {
        mainTitle: 'The Ultimate Home Service Ecosystem That Changes Everything',
        sections: [
            {
                title: 'Instant Expert Advisory Platform',
                description: 'Give homeowners immediate access to certified professionals the moment they face confusing or urgent issues—via chat, video, or photos.',
                image: '/images/industries/homecare/h3.png',
                imageAlt: 'Instant Expert Advisory Platform',
                imagePosition: 'left',
                features: [
                    'Real experts, not random forum answers',
                    '24/7 availability because disasters don’t keep office hours',
                    'Chat, video, or photo support based on context',
                    'Certified professionals homeowners can trust',
                    'Save money by avoiding unnecessary service calls',
                    'Triage guidance that differentiates 911 vs DIY-first steps',
                ],
            },
            {
                title: 'Lightning-Fast Professional Booking System',
                description: 'Connect homeowners with the right, available professional in under 60 seconds—with instant confirmations and fair, dynamic pricing.',
                image: '/images/industries/homecare/h4.png',
                imageAlt: 'Lightning-Fast Professional Booking',
                imagePosition: 'right',
                features: [
                    'One-tap booking flows that remove friction',
                    'Show only currently available contractors',
                    'Smart matching on skills, location, urgency, and job details',
                    'Instant confirmation to reduce anxiety and delays',
                    'Fair pricing adjusted to real-time local conditions',
                    'Emergency jobs automatically prioritized to the front of the queue',
                ],
            },
            {
                title: 'Predictive Home Health Intelligence',
                description: 'AI and IoT signals detect early warning signs and recommend maintenance before costly failures happen—turning surprise breakdowns into planned fixes.',
                image: '/images/industries/homecare/h5.png',
                imageAlt: 'Predictive Home Health Intelligence',
                imagePosition: 'left',
                features: [
                    'Friendly reminders before small problems become big',
                    'Replace aging equipment before catastrophic failures',
                    'Spot abnormal usage patterns that indicate hidden issues',
                    'Auto-book maintenance at optimal times',
                    'Plan future repairs to avoid emergency premiums',
                    'Track money saved by preventing breakdowns',
                ],
            },
            {
                title: 'Homeowner Command Center & Insights Hub',
                description: 'A centralized dashboard for everything about the home: jobs, spend, documents, warranties, and project tracking—organized and actionable.',
                image: '/images/industries/homecare/h6.png',
                imageAlt: 'Homeowner Command Center & Insights Hub',
                imagePosition: 'right',
                features: [
                    'All repairs, upgrades, and maintenance history in one place',
                    'Spending analytics to see where money goes',
                    'Track ROI on upgrades and improvements',
                    'Secure storage for invoices, warranties, and permits',
                    'Smart reminders for maintenance and renewals',
                    'Live project tracking to ensure contractors deliver',
                ],
            },
            {
                title: 'Neighborhood Network & Trust Platform',
                description: 'Leverage verified local community insights so homeowners can confidently choose professionals who truly perform in their area.',
                image: '/images/industries/homecare/h7.png',
                imageAlt: 'Neighborhood Network & Trust Platform',
                imagePosition: 'left',
                features: [
                    'Recommendations from nearby homeowners',
                    'Verified, consequence-based community reviews',
                    'Find pros who understand local codes and conditions',
                    'Surface top performers and filter out unreliable contractors',
                    'Trust-building through authenticated neighborhood feedback',
                    'Local insights that drive smarter hiring decisions',
                ],
            },
        ],
    };

    const servicesContent = {
        title: 'The Premium Development Solutions That Dominate Markets',
        cards: [
            {
                icon: '/images/industries/homecare/17.svg',
                title: 'Proprietary AI Job-Matching Technology',
                description: 'Our smart algorithms instantly connect homeowners with perfectly matched contractors based on skills, availability, and location.',
                buttonText: 'Discover More',
            },
            {
                icon: '/images/industries/homecare/18.svg',
                title: 'Bulletproof Contractor Screening & Compliance Systems',
                description: 'Detailed background checks, license verification, and insurance validation ensure only qualified professionals join your platform.',
                buttonText: 'Discover More',
            },
            {
                icon: '/images/industries/homecare/19.svg',
                title: 'Universal Cross-Device Application Engineering',
                description: 'Seamless experiences across smartphones, tablets, and desktops keep users engaged no matter which device they choose.',
                buttonText: 'Discover More',
            },
            {
                icon: '/images/industries/homecare/20.svg',
                title: 'Smart Home Integration & Device Connectivity',
                description: 'Connect with popular IoT devices and home automation systems for predictive maintenance and enhanced functionality.',
                buttonText: 'Discover More',
            },
            {
                icon: '/images/industries/homecare/21.svg',
                title: 'Business Intelligence & Performance Analytics',
                description: 'Real-time dashboards and detailed reporting help optimize operations, track growth, and drive data-informed decisions.',
                buttonText: 'Discover More',
            },
        ],
    };

    const whyChooseContent = {
        title: 'Why Industry Leaders Trust Our Home Service Development Expertise',
        image: h8,
        imageAlt: 'Why Choose Us for Home Service App Development',
        items: [
            {
                title: 'Proven Track Record Building Market-Leading Platforms',
                desc: "We've launched successful home service apps that dominate their markets consistently.",
            },
            {
                title: 'Custom Solutions Engineered for Your Unique Business Model',
                desc: 'Every platform we build perfectly matches your specific requirements and business goals.',
            },
            {
                title: 'Never-To-Be-Breached Security Architecture',
                desc: 'Military-grade protection safeguards sensitive customer data against cyber attacks.',
            },
            {
                title: 'Code Built For Future Growth And Expansion',
                desc: 'Scalable architecture that grows smoothly as your user base and features expand.',
            },
            {
                title: '24/7 Technical Support That Keeps You Online',
                desc: 'Round-the-clock support to minimize downtime and keep your platform running.',
            },
        ],
    };

    const faqContent = {
        title: "Got Questions? We've Got Answers",
        questions: [
            {
                q: "How do you ensure our pet app will actually engage users long-term? ",
                a: "We combine behavioral psychology, gamification, AI personalization, and community features to create pet care experiences that owners use daily, not just during emergencies."
            },
            {
                q: "Do you connect with other veterinary practice management systems?",
                a: "We certainly do, and because seamless PMS integration is our specialty, we safeguard your data and introduce powerful new capabilities that complement all of your existing processes."
            },
            {
                q: "What is your strategy in managing sensitive pet health data?",
                a: "We employ a high level of military encryption, frequent security scans, and the close adherence to the compliance procedures to have the pet medical data of high-security standards and compliant with all legal requirements."
            },
            {
                q: "How much time may a custom pet care app take?",
                a: "Timelines can vary depending on complexity but most comprehensive pet apps are launched in 4-6 months with subsequent features and support available whenever you need."
            }
        ]
    };

    return (
        <>
            <Navigation offer={true} />
            <Hero homeContent={homeContent} />
            <div data-aos="fade-up">
                <IndustryChallengesAndSolutions industryChallengesAndSolutionsContent={industryChallengesAndSolutionsContent} />
            </div>
            <div data-aos="fade-up">
                <IndustryTech industryTechContent={industryTechContent} />
            </div>
            <div data-aos="fade-up">
                <AISearch aiSearchContent={aiSearchContent} />
            </div>
            <div data-aos="fade-up">
                <SpecializedServices servicesContent={servicesContent} />
            </div>
            <div data-aos="fade-up">
                <WhyChoose whyChooseContent={whyChooseContent} />
            </div>
            <div data-aos="fade-up">
                <CaseStudies />
            </div>
            <div data-aos="fade-up">
                <ClientSpeak />
            </div>
            <div data-aos="fade-up">
                <GetQuote />
            </div>
            <div data-aos="fade-up">
                <Contect />
            </div>
            <Footer />
        </>
    )
}

export default Homecare
